"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _text = babelHelpers.interopRequireDefault(require("./text"));

var instance = new _text.default('privacy-sidebar-modal', 'Privacy Policy', 'data/legal?notice=PrivacyPolicy');
var _default = instance;
exports.default = _default;